import { useMutation, useQuery, useQueryClient } from 'react-query';

import {
  createCompanyStockConfigurationFields,
  createCompanyStockConfigurationFixedCost,
  createCompanyStockConfigurationProfitMargin,
  getCompanyStockConfiguration,
  getPartConfigurationProfile,
  updatePartConfigurationProfile,
} from './Configuration.service';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export function useCompanyStockConfiguration(companyId?: number) {
  return useQuery(
    ['companyStockConfiguration', companyId],
    () => getCompanyStockConfiguration(companyId),
    {
      enabled: !!companyId,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function usePartConfigurationProfile(enabled = true) {
  const cache = queryClient.getQueryData(['parts/configuration/profile']);

  return useQuery(
    ['parts/configuration/profile'],
    () => {
      return getPartConfigurationProfile();
    },
    {
      enabled: !cache && enabled,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useUpdatePartConfigurationProfile() {
  const queryChanel = useQueryChanel();
  return useMutation(updatePartConfigurationProfile, {
    onSuccess() {
      queryChanel({
        refetchQueries: [['parts/configuration/profile']],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useUpdateCompanyStockConfigurationFields() {
  const query = useQueryClient();

  return useMutation(createCompanyStockConfigurationFields, {
    onSuccess() {
      query.invalidateQueries(['companyStockConfiguration']);
      notification.success({
        message: 'Sucesso',
        description: 'Composição de Preços atualizada.',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useUpdateCompanyStockConfigurationFixedCost() {
  const queryChanel = useQueryChanel();

  return useMutation(createCompanyStockConfigurationFixedCost, {
    onSuccess(_, vars) {
      notification.success({
        message: 'Sucesso',
        description: 'Custo Fixo Atualizado',
      });

      queryChanel({
        invalidateQueries: [['companyStockConfiguration', vars.companyId]],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useUpdateCompanyStockConfigurationProfitMargin() {
  const query = useQueryClient();

  return useMutation(createCompanyStockConfigurationProfitMargin, {
    onSuccess() {
      query.invalidateQueries(['companyStockConfiguration']);
      notification.success({
        message: 'Sucesso',
        description: 'Percentual de Lucro Fixo Atualizado',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
